import request from './handler'

const getListPlan = () => request.get('/workplan')
const getListPlanStatus = () => request.get('/workplan/status')
const post = form => request.post('/workplan', form)
const deletePlan = id => request.delete(`/workplan?id=${id}`)
const getIdPlan = id => request.get(`/workplan/${id}`)
const updatePlan = (id, form) => request.put(`/workplan?id=${id}`, form)

export default {
  getListPlan,
  getListPlanStatus,
  post,
  deletePlan,
  getIdPlan,
  updatePlan
}
